import { Gift, type LucideIcon, Megaphone, Sparkles } from "lucide-react"

import type { MissionType } from "@/types/collab"

/**
 * OKS-938 — Shared mission-type chip config, lifted out of `collab-card.tsx`
 * where it was a file-local const (OKS-7 era).
 *
 * ## Why this is a config object and not a `<MissionTypeChip>` component
 *
 * Two cards render the type chip with different surrounding markup and
 * different testids (`CollabCard` uses `collab-card-type-{type}`;
 * `MissionCard` uses `mission-card-type-chip` inside the overlay chip
 * cluster). A shared component would have to either change `CollabCard`'s
 * DOM — which is shipped and parity-tested — or grow props to preserve it,
 * which is a component in name only.
 *
 * Extracting the CONFIG instead is the minimal change that satisfies "lift,
 * don't duplicate": both cards read one source of truth for icon + label key
 * + Badge variant, and `CollabCard`'s render stays byte-identical.
 *
 * Icon note: `open` shares `Sparkles` with the XP reward chip. Accepted
 * deliberately (UX Spec §10.5) — both carry text labels and sit in different
 * regions of the card, so nothing is icon-only.
 */
export interface MissionTypeChip {
  icon: LucideIcon
  labelKey: string
  variant: "secondary" | "outline"
}

export const MISSION_TYPE_CHIPS: Record<MissionType, MissionTypeChip> = {
  drop: {
    icon: Gift,
    labelKey: "creator_home.type.drop",
    variant: "secondary",
  },
  promotional: {
    icon: Megaphone,
    labelKey: "creator_home.type.promotional",
    variant: "outline",
  },
  open: {
    icon: Sparkles,
    labelKey: "creator_home.type.open",
    variant: "secondary",
  },
}
